module.exports = __webpack_public_path__ + "img/hero_landlord.877cb4bb.png";